// extracted by mini-css-extract-plugin
export var styles = "content-module--styles--2OnMa";
export var zzz = "content-module--zzz--22K9v";